import Mock from 'mockjs'
import * as common from './modules/common'
import * as tablemeta from './modules/customform_tablemeta'
import * as columninfo from './modules/customform_columninfo'
import * as demoMock from './modules/demo'
import * as sysMenu from './modules/sys-menu'
import * as customList from './modules/custom_list'

// tips
// 1. 开启/关闭[业务模块]拦截, 通过调用fnCreate方法[isOpen参数]设置.
// 2. 开启/关闭[业务模块中某个请求]拦截, 通过函数返回对象中的[isOpen属性]设置.
// fnCreate(demoMock, true)
// fnCreate(sysMenu, false)
// fnCreate(tablemeta, false)
// fnCreate(columninfo, false)
// fnCreate(customList, false)
//     fnCreate(common, true)

/**
 * 创建mock模拟数据
 * @param {*} mod 模块
 * @param {*} isOpen 是否开启?
 */
function fnCreate(mod, isOpen = true) {
    console.log('mock init ', mod)
    if (isOpen) {
        for (var key in mod) {
            ((res) => {
                if (res.isOpen !== false) {
                    Mock.mock(new RegExp(res.url), res.type, (opts) => {
                        try {
                            opts['data'] = opts.body ? JSON.parse(opts.body) : null
                        } catch (e) {
                            opts['data'] = {}
                            console.log(e)
                        }
                        delete opts.body
                        let resultData = {}
                        if (res.getDataByOpts !== undefined) {
                            resultData = res.getDataByOpts(opts.data)
                        } else {
                            resultData = res.data
                        }
                        console.log('%cmock拦截, 请求: ', 'color:blue', opts)
                        console.log('%cmock拦截, 响应: ', 'color:blue', resultData)
                        return resultData
                    })
                }
            })(mod[key]() || {})
        }
    }
}